<template>
  <div>
    <div
      v-if="loading"
      class="flex items-center justify-center h-64 p-32"
    >
      <vue-element-loading
        :active="loading"
        spinner="spinner"
        color="#DBDBDB"
        background-color="rgba(255, 255, 255, .5)"
      />
    </div>
    <div
      class="container px-6 mt-4"
      v-else
    >
      <h1 class="pl-4 text-lg font-bold uppercase md:pl-6">
        <span class="text-pink-500">1.</span> {{ $t('messages.profile_tabs.steps.personal_information')}}
      </h1>
      <div>
      </div>
      <div class="flex flex-wrap mt-6">
        <div
          class="w-full px-0 py-2 md:w-1/2 md:px-6"
          :class="{ 'form-group--error': errors.first('step1.firstname') }"
        >
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.name') }}</label>
          <input
            v-model="form.first_name"
            class="block w-full h-12 pl-6 mt-2 font-semibold text-gray-700 border border-blue-500 rounded outline-none"
            type="text"
            name="firstname"
            placeholder="John Gregory"
            data-vv-scope="step1"
            :data-vv-as="$t('messages.step_one.name')"
            v-validate="'required|alpha_spaces'"
          >
          <ul>
            <li
              v-for="(error, index) in errors.collect('step1.firstname')"
              :key="index"
              class="mt-2 text-sm font-semibold text-red-500 is-danger"
            >
              {{ error }}
            </li>
          </ul>
        </div>
        <div
          class="w-full px-0 py-2 md:w-1/2 md:px-6 "
          :class="{'form-group--error': errors.first('step1.lastname') }"
        >
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.last_name')}}</label>
          <input
            v-model="form.last_name"
            class="block w-full h-12 pl-6 mt-2 font-semibold text-gray-700 border border-blue-500 rounded outline-none"
            type="text"
            name="lastname"
            placeholder="Doe Smith"
            data-vv-scope="step1"
            v-validate="'required'"
            :data-vv-as="$t('messages.step_one.last_name')"
          >
          <ul>
            <li
              v-for="(error, index) in errors.collect('step1.lastname')"
              :key="index"
              class="mt-2 text-sm font-semibold text-red-500 is-danger"
            >
              {{ error }}
            </li>
          </ul>
        </div>
        <div
          class="w-full px-0 py-2 md:w-1/2 md:px-6"
          :class="{'form-group--error': errors.first('step1.userEmail')}"
        >
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.email') }}</label>
          <input
            v-model="form.email"
            class="block w-full h-12 pl-6 mt-2 font-semibold text-gray-700 border border-blue-500 rounded outline-none"
            type="email"
            name="userEmail"
            placeholder="doe.john@gmail.com"
            data-vv-scope="step1"
            v-validate="'required|email|unique_email'"
            :data-vv-as="$t('messages.step_one.email')"
            readonly
          >
          <ul>
            <li
              v-for="(error, index) in errors.collect('step1.userEmail')"
              :key="index"
              class="mt-2 text-sm font-semibold text-red-500 is-danger"
            >
              {{ error }}
            </li>
          </ul>
        </div>
        <div
          class="w-full px-0 py-2 md:w-1/2 md:px-6"
          :class="{'form-group--error': errors.first('step1.username')}"
        >
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.username') }}</label>
          <input
            v-model="form.username"
            class="block w-full h-12 pl-6 mt-2 font-semibold text-gray-700 border border-blue-500 rounded outline-none"
            type="text"
            name="username"
            placeholder="Ej: dreamer96, Sunnyman500 …"
            data-vv-scope="step1"
            v-validate="{
              required: true,
              unique_username: true,
              regex: /^[a-zA-Z0-9_-]{4,24}$/,
            }"
            :data-vv-as="$t('messages.step_one.username')"
            v-blockuser
            v-blockemojis
            v-on:input="handleChange('username')"
            @click="user_controll()"
          >
          <ul>
            <li
              v-for="(error, index) in errors.collect('step1.username')"
              :key="index"
              class="mt-2 text-sm font-semibold text-red-500 is-danger"
            >
              {{ error }}
            </li>
          </ul>
        </div>
        <div
          class="w-full px-0 py-2 md:w-1/2 md:px-6 "
          :class="{'form-group--error': errors.first('step1.password')}"
        >
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.password') }}</label>
          <input
            v-model="form.password"
            class="block w-full h-12 pl-6 mt-2 font-semibold text-gray-700 border border-blue-500 rounded outline-none"
            type="password"
            name="password"
            placeholder="Ctimber23!"
            data-vv-scope="step1"
            v-validate="'min:8|max:32|strong_password'"
            :data-vv-as="$t('messages.step_one.password')"
            ref="password"
          >
          <span class="mt-2 text-sm font-semibold text-red-500 is-danger">
            {{ errors.first('step1.password') }}
          </span>
        </div>
        <div
          class="w-full px-0 py-2 md:w-1/2 md:px-6 "
          :class="{'form-group--error': errors.first('step1.repeatPassword')}"
        >
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.confirm_password') }}</label>
          <input
            v-model="form.repeatPassword"
            class="block w-full h-12 pl-6 mt-2 font-semibold text-gray-700 border border-blue-500 rounded outline-none"
            type="password"
            name="repeatPassword"
            placeholder="Ctimber23!"
            data-vv-scope="step1"
            :data-vv-as="$t('messages.step_one.confirm_password')"
            v-validate="'confirmed:password'"
          >
          <ul>
            <li
              v-for="(error, index) in errors.collect('step1.repeatPassword')"
              :key="index"
              class="mt-2 text-sm font-semibold text-red-500 is-danger"
            >
              {{ error }}
            </li>
          </ul>
        </div>
        <div
          class="w-full px-0 py-2 md:px-6 "
          :class="{'form-group--error': errors.first('step1.message_profile')}"
        >
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.profile_message') }}</label>
          <input
            v-model="form.message_profile"
            class="block w-full h-12 pl-6 mt-2 font-semibold text-gray-700 border border-blue-500 rounded outline-none"
            type="text"
            name="message_profile"
            data-vv-scope="step1"
            :data-vv-as="$t('messages.step_one.profile_message')"
            v-validate="'required|max_words:10'"
            v-on:input="handleChange('profile_message')"
            @click="modalSubscribed()"
          >
          <ul>
            <li
              v-for="(error, index) in errors.collect('step1.message_profile')"
              :key="index"
              class="mt-2 text-sm font-semibold text-red-500 is-danger"
            >
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
      <h1 class="pl-6 mt-6 text-lg font-bold text-blue-500 uppercase ">
        {{ $t('messages.step_one.birthdate')}}
      </h1>
      <v-date-picker
        v-model="form.birthday"
        :format="format"
        :start="maxStartDate"
        :default="date"
        vvscope="step1"
        valid-scope="step1"
        ref="datePicker"
        :end="maxEndDate"
        @changeDate="storeDate"
      ></v-date-picker>
      <div class="flex flex-wrap mt-2 lg:">
        <div class="w-full px-0 py-2 md:w-1/2 md:px-6">
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.country') }}</label>
          <SelectInput
            @selected="setSelectedCountry"
            @typing="clearCity"
            :withimages="true"
            itemkey="id"
            imagekey="url"
            namekey="name"
            :disabled="false"
            placeholder="Portugal"
            vvclass="form-group--error"
            vvscope="step1"
            vvname="country"
            :vvdata="$t('messages.step_one.country')"
            :require="true"
            :items="orderedCountries"
            :vvtext="selectedCountryText"
            :selecteditem="selectedCountry"
            :locale="locale"
            hasLocale
            sorted
          />
        </div>
        <div class="w-full px-0 py-2 md:w-1/2 md:px-6">
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.city') }}</label>
          <SelectInput
            @selected="setSelectedCity"
            itemkey="name"
            namekey="name"
            :disabled="false"
            vvclass="form-group--error"
            vvscope="step1"
            vvname="city"
            :vvdata="$t('messages.step_one.city')"
            :require="true"
            :items="cities"
            :selecteditem="selectedCity"
            :vvtext="selectedCityText"
          />
        </div>
        <div class="w-full px-0 py-2 md:w-1/2 md:px-6">
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.phone')}}</label>
          <vue-tel-input
            v-model="form.phone_mobile"
            v-bind="phoneProps"
            :dynamicPlaceholder="true"
            class="items-center block w-full h-12 p-2 pl-6 mt-2 font-semibold text-gray-700 border border-blue-500 rounded"
          >
          </vue-tel-input>
          <span class="w-1/2 pt-6 text-sm font-semibold text-blue-500">{{ $t('messages.step_one.verify_phone')}}</span>
        </div>
        <div
          class="w-full px-0 py-2 md:w-1/2 md:px-6"
          :class="{'form-group--error': errors.first('step1.zip_code')}"
        >
          <label class="font-semibold">{{ $t('messages.step_one.postal_code') }}</label>
          <input
            v-model="form.zip_code"
            class="block w-full h-12 pl-6 mt-2 font-semibold text-gray-700 border border-blue-500 rounded"
            type="text"
            data-vv-scope="step1"
            :data-vv-as="$t('messages.step_one.postal_code')"
            name="zip_code"
            placeholder="1011"
          >
          <ul>
            <li
              v-for="(error, index) in errors.collect('step1.zip_code')"
              :key="index"
              class="mt-2 text-sm font-semibold text-red-500 is-danger"
            >
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <transition name="modal">
      <div v-if="showUsernameModal && !showUsernameModalShowed">
        <div
          class="z-50 flex items-center justify-center w-full h-full px-2 overlay lg:px-0"
          @click.self="showUsernameModal = false; showUsernameModalShowed = true"
        >
          <div
            class="w-full p-4 mx-auto my-0 bg-white rounded-lg modal md:w-1/2 lg:p-6 overflow-auto"
          >
            <div class="container px-0 m-auto lg:px-10 overflow-auto">
              <div class="mb-4 text-sm text-justify">
                {{ $t('messages.usernameAlert.text') }}
              </div>
            </div>
            <div class="flex justify-center">
              <button
                class="px-2 mx-2 text-sm tracking-wide bg-jblue-primary text-white"
                @click.prevent="showUsernameModal = false; showUsernameModalShowed = true"
              >{{ $t('messages.general.busy_call.accept') }}</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import "vue-tel-input/dist/vue-tel-input.css";
import VueTelInput from "vue-tel-input";
import Question from "@/components/Question.vue";
import _ from 'lodash';
import bus from "@/bus";

import VDatePicker from "@/components/VDatePicker.vue";

export default {
  name: "RegisterStepOne",
  components: {
    VDatePicker,
    Question,
    VueTelInput
  },
  props: ["loading"],
  data: () => ({
    showUsernameModal: false,
    showUsernameModalShowed: false,
    isOpen: false,
    format: "YYYY-MM-DD",
    vvScope: "step1",
    date: "1991-1-1",
    hasCity: false,
    options: [
      { icon: "icon-woman text-pink-500", text: "Mujer", value: "female" },
      { icon: "icon-man text-blue-500", text: "Hombre", value: "male" }
    ],
    range_slide: {
      range_age: [18, 100]
    },
    form: {},
    phoneProps: {
      defaultCountry: "",
      disabledFetchingCountry: false,
      disabled: false,
      disabledFormatting: false,
      placeholder: "7789 4567",
      enabledCountryCode: false,
      enabledFlags: true,
      preferredCountries: ["SV", "US"],
      onlyCountries: [],
      ignoredCountries: [],
      autocomplete: "on",
      name: "telephone",
      maxLen: 25,
      wrapperClasses: "",
      inputClasses: "",
      dropdownOptions: {
        disabledDialCode: false
      },
      inputOptions: {
        showDialCode: false
      },
      validCharactersOnly: true
    },
    res_genre: "Hombre",
    icon_genre: "icon-man text-blue-500",
    picked: {
      id: 1,
      icon: "icon-woman text-pink-500",
      text: "Mujer",
      value: "female",
      match: "Hombre"
    },
    genre: [
      {
        id: 1,
        icon: "icon-woman text-pink-500",
        text: "Mujer",
        value: "female",
        match: "Hombre"
      },
      {
        id: 2,
        icon: "icon-man text-blue-500",
        text: "Hombre",
        value: "male",
        match: "Mujer"
      }
    ],
    orderedCountries: [],
    selectedCountry: null,
    cities: [],
    selectedCity: null,
    selectedCountryText: '',
    selectedCityText: ''
  }),
  watch: {
    isOpen(isOpen) {
      if (isOpen) {
        document.addEventListener("click", this.closeDropdown);
      }
    },
    picked(val) {
      if (val.value === "male") {
        this.res_genre = "Mujer";
        this.icon_genre = "icon-woman text-pink-500";
        this.form.gender = "male";
      } else if (val.value === "female") {
        this.res_genre = "Hombre";
        this.icon_genre = "icon-man text-blue-500";
        this.form.gender = "female";
      }
    }
  },
  async created() {
    await this.fetchUser();
    this.form = Object.assign({}, this.user.profile);
    this.form.id = this.user.id;
    this.form.email = this.user.email;
    this.form.username = this.user.username;
    this.form.message_profile = this.user.profile.message_profile;
    var date = this.user.profile.birthday.split("-").join(".");
    date = date.split(" ");
    this.date = date[0];
    await this.getQuestions();
    await this.listCountries();
    this.orderedCountries = this.countries
      .filter(country => !!country.url)
      .slice();
    this.selectedCountry = this.countries.filter(
      item => item.id === this.user.profile.country_id
    )[0];

    this.cities = await this.countryCities(this.user.profile.country_id);
    this.selectedCity = this.cities.filter(
      city => city.name === this.user.profile.city
    )[0];

    this.setCountryText();
    this.setCityText();
  },
  computed: {
    ...mapState("questions", ["questions"]),
    ...mapState("answer", ["answers"]),
    ...mapState("countries", ["countries"]),
    ...mapState("auth", ["user"]),
    ...mapState("locale", ["locale"]),
    maxEndDate() {
      const dt = new Date();
      // currentYear - min range age (18) = maxEnd year
      // concatenated with last day of the year, which is december(12) 31
      let day = dt.getDate();
      let month = dt.getMonth()+1;
      return dt.getFullYear() - 18 + `.${month}.${day}`;
    },
    maxStartDate() {
      const dt = new Date();
      return dt.getFullYear() - this.range_slide.range_age[1] + ".01.01";
    }
  },

  methods: {
    ...mapActions("questions", ["getQuestions"]),
    ...mapActions("answer", ["saveAnswersForm"]),
    ...mapActions("countries", ["listCountries", "countryCities"]),
    ...mapActions("auth", ["fetchUser"]),

    handleChange(from='') {
      bus.$emit('input-changed', from);
    },

    setCountryText() {
      this.selectedCountryText = this.selectedCountry.name[this.locale];
    },
    async user_controll() {
      this.$swal.fire({
                text:  this.$t('messages.usernameAlert.text'),
                confirmButtonText: this.$t('messages.general.busy_call.accept'),
                focusConfirm: false,
                confirmButtonColor : "#1C4C91",
              })

              this.modalSubscribed();
    },
    modalSubscribed() {
      if (this.$store.state.auth.user.subscription_status &&  this.$store.state.auth.user.subscription_status === 'active' )
        return;
      if (this.$store.state.auth.user.enable_edit_profile)
        return;

      this.$swal
          .fire({
            html:`<b><p style = ' color: #1c4c91;'> ${ this.$t('edit_profile_limit.message')}</p></b> <br>`,
            width: 560,
            confirmButtonText: this.$t('messages.general.subscribe'),
            allowOutsideClick: false,
            confirmButtonColor: '#1C4C91',
            background: 'center #EFF3F2 url(https://jwperfectmatch.com/storage/image/banner-profile-subscribe.webp) no-repeat'
          }).then(result =>{
              if (result.value) {
                this.$router.push('../subscriptions');
              }
            });
    },

    setCityText() {
      this.selectedCityText = _.get(this.selectedCity, 'name', '');
    },

    async setSelectedCountry(country) {
      this.cities = country ? await this.countryCities(country) : [];
      this.$set(this.form, "country_id", country);
      this.$set(this.form, "city", null);
      this.$set(this.form, "country", _.find(this.countries, item => item.id === country));
      this.selectedCountry = this.countries.find(item => item.id === country);
      this.selectedCity = null;

      this.setCountryText();
      this.clearCity();
    },
    clearCity() {
      this.$set(this.form, "city", null);
      this.hasCity = false;
    },
    setSelectedCity(city) {
      this.selectedCity = this.cities.filter(item => item.name === city)[0];
      this.form.city = city;

      this.setCityText();
    },
    changeAnswer(event) {
      this.saveAnswersForm({
        type: event.target.name,
        field: event.target.value
      });
    },
    getData() {
      this.form.range = this.range_slide.range_age;
      return this.form;
    },
    storeDate(value) {
      this.form.birthday = value;
    },
    closeDropdown() {
      if (!event.target.closest(".dropdown")) {
        this.isOpen = false;
      }
    }
  }
};
</script>
<style lang="scss">
.form-group--error input,
.form-group--error textarea,
.form-group--error select,
.form-group--error input:focus,
.form-group--error input:hover {
  border-color: #f79483;
}

.steps-wrapper {
  .step {
    .circle {
      i[data-v-3ee86246] {
        background-color: #f35a78 !important;
      }
    }
  }
}
.custom-dot {
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background-color: #D8406C;
  transition: all 0.3s;
}
.custom-dot:hover {
  transform: rotateZ(45deg);
  cursor: pointer;
}
.custom-dot.focus {
  border-radius: 50%;
}
</style>
